(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-js*="header-sticky"]');
    if (!bar) return;

    var stickyClass = 'header-sticky';
    var isIndex = document.body.classList.contains('p-index');
    var transparentAtTop = bar.dataset.transparentAtTop === 'true';

    function setSticky(shouldStick) {
      document.body.classList.toggle(stickyClass, shouldStick);
      bar.classList.toggle(stickyClass, shouldStick);
      bar.style.left = shouldStick && window.scrollX > 0 ? -window.scrollX + 'px' : '';
    }

    function onScroll() {
      if (isIndex && transparentAtTop) {
        setSticky(window.scrollY > 0);
        return;
      }

      var header = bar.closest('.cj-header');
      var top = header ? header.getBoundingClientRect().top : bar.parentNode.getBoundingClientRect().top;
      setSticky(top < 0);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
